<!-- 
  详情页 - 供应商采购记录
  props:
    id: 详情id
  emit:
    openDetail: 打开详情页
 -->

<template>
	<div class="v-tabs notes-list">
		<div class="head">
      <div class="total">
        累计{{purchaseData.length}}次采购记录
      </div>
      <div class="inline-item">
        <el-date-picker
          v-model="date"
          @change="datepicker"
          value-format="yyyy-MM-dd"
          size="small"
          type="daterange"
          style="width:180px"
          unlink-panels
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
    </div>
    <div class="content" ref="content">
      <ul class="item-list">
        <li class="item center" v-if="!purchaseData.length">暂无数据</li>
        <li class="item" v-for="item in purchaseData">
          <span class="date">{{item.addTime}}</span>
          <div class="order">
            <div class="id">
              <i class="ico purple" v-if="item.type === 1">购</i>
              <i class="ico red" v-if="item.type === 2">退</i>
              <a @click="openDetail(item.id, item.type)">{{item.sheetNo}}</a>
            </div>
            <div class="good">
              <span class="thumb">
                <img :src="item.productImg" alt="">
              </span>
              <span class="title">{{item.productKind}}种商品 共{{item.productNum}}件</span>
              <span class="price">¥{{item.amount}}</span>
            </div>
            <div class="response">负责人：{{item.userName}}</div>
            <span class="status green">{{item.status}}</span>
          </div>
        </li>
      </ul>

      <div class="pagination-wrapper" v-if="total > pageSize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 25, 30, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
	</div>
</template>

<script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 30,
      total: 0,
      purchaseData: [],
      date: []
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    datepicker (val) {
      if (val) {
        this.date = val
      } else {
        this.date = []
      }
      this.getList()
    },
    // 详情跳转
    openDetail (id, type) {
      let module = 'purchase'
      if (type === 2) {
        module = 'returnedPurchase'
      }
      this.$emit('openDetail', module, id)
    },
    getList () {
      let url = '/supplier/purchaseList.html'
      let params = {
        supplierId: this.id,
        page: this.currentPage,
        pageSize: this.pageSize,
        addTime: this.date.length ? this.date : []
      }
      api.post(url, params, (data) => {
        this.purchaseData = data.result
        this.total = data.pageHelper.rowsCount
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// purchase-record.vue?345ecd50